import script from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=23017352&lang=scss"

const __exports__ = script;

export default __exports__